/**
 * Who may see which supplier a fare came from on the flight SRP.
 *
 * Deliberately an explicit list rather than `isInternalUser`, which admits anyone with an
 * @cleartrip or @flyin address. Supplier names are commercially sensitive, so this stays a
 * named set that someone has to edit on purpose.
 */
const SUPPLIER_ACCESS_EMAILS = [
    'prasad.bandaruvc@flyin.com',
    'jay.prakash@flyin.com',
    'anirudh.damodar@flyin.com',
    'sandeep.nair@flyin.com',
    'kulasekar.reddy@flyin.com',
    'sourabh@flyin.com',
    'pradnyavant.w@flyin.com'
]

/** The `userid` cookie holds "email|id". */
export const getEmailFromUseridCookie = (useridCookie?: string | null): string => {
    if (!useridCookie) return ''
    try {
        const [email] = decodeURIComponent(useridCookie).split('|')
        return email || ''
    } catch {
        return ''
    }
}

export const canViewSupplier = (email?: string | null): boolean =>
    !!email && SUPPLIER_ACCESS_EMAILS.includes(email.trim().toLowerCase())
